export const MOBILE_DRAWER_OPEN = 'yeself/app/MOBILE_DRAWER_OPEN';
export const ACTIONS_DRAWER_IS_SHOWN = 'yeself/app/ACTIONS_DRAWER_IS_SHOWN';
export const ACTIONS_DRAWER_IS_LOADING = 'yeself/app/ACTIONS_DRAWER_IS_LOADING';
export const ACTIONS_DRAWER_WRAPPER_IS_SHOWN = 'yeself/analytics/ACTIONS_DRAWER_WRAPPER_IS_SHOWN';

export const CHANGE_CONSOLE_LANGUAGE = 'yeself/app/CHANGE_CONSOLE_LANGUAGE';
export const CHANGE_CONTENT_LANGUAGE = 'yeself/app/CHANGE_CONTENT_LANGUAGE';
export const INITIALIZE_CONTENT_LANGUAGE = 'yeself/app/INITIALIZE_CONTENT_LANGUAGE';
export const INITIALIZE_CONTENT_LANGUAGE_SUCCESS = 'yeself/app/INITIALIZE_CONTENT_LANGUAGE_SUCCESS';
